<script type="text/jsx">
import partnerCartBase from '@/views/config/partner-refer/component/partner-cart-base.vue';

export default {
  extends: partnerCartBase,
};

</script>
